<script setup>
import { Loc } from 'main.core';
import InfoBlock from './InfoBlock.vue';
import useCalculatorStore from '../store/calculator.js';

const calculator = useCalculatorStore();
</script>

<template>
  <InfoBlock v-if="calculator.priceDate || calculator.priceDetailsUrl" :modifiers="['info']">
    <p v-if="calculator.priceDate">
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PRICES_DATE_INFO', {'#DATE#': calculator.priceDate }) }}
    </p>
    <p v-if="calculator.priceDetailsUrl">
      <a :href="calculator.priceDetailsUrl" target="_blank">
        {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_BUTTON_PRICE_DETAILS') }}
      </a>
    </p>
  </InfoBlock>
</template>
